import { useParams } from 'react-router-dom';

export const useOpportunityId = () => useParams<Dictionary<string>>().id!;
